/* eslint-disable react/prop-types */
import classes from "./admin-dasboard.module.scss";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import AnnouncementList from "@/common/components/announcement-list";
import Label from "@/components-library/widgets/label";
function AdminDashboard({
  announcements,
  status,
  onCreateClick,
  onVisuraClick,
  onLoadTecnicalPdfClick,
}) {
  return (
    <Flex
      align="flex-start"
      className={classes.dashboard}
      direction="column"
      justify="flex-start"
    >
      <Label
        tag="h1"
        weight="bold"
        color="secondary"
        className={classes.title}
        align="start"
      >
        Admin dashboard
      </Label>

      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        className={classes.subTitle}
      >
        Aggiungi un bando
      </Label>

      <Flex align="center" direction="row" justify="center">
        <Button
          onClick={onCreateClick}
          size="sm"
          color="primary"
          className={classes.button}
        >
          CREA BANDO
        </Button>
        <Button
          onClick={onVisuraClick}
          size="sm"
          color="primary"
          className={classes.button}
        >
          CARICA VISURA
        </Button>
        <Button
          onClick={onLoadTecnicalPdfClick}
          size="sm"
          color="primary"
          className={classes.button}
        >
          CARICA SCHEDA TECNICA
        </Button>
      </Flex>

      <AnnouncementList
        announcements={announcements}
        status={status}
        admin={true}
      />
    </Flex>
  );
}

export default AdminDashboard;
